$(".modal-body").hide();
$( document ).ready(function() {
var custom_length = $(".product__inventory").html();
//console.log(custom_length);

setTimeout(function(){
  if(custom_length.trim() !== ""){
    $(".product__pickup-availabilities").show();
  } else {
    $(".product__pickup-availabilities").hide();
$(".delivery_time").hide();
  }
}, 2000);

if ($('.custom_coll').length) {
    $('.collection__contact-link').hide();
  }
 if ($('.custom__pdpcontact-tag').length) {
    $('.custom_priceinfo').hide();
  }
// if($(".custom__ship-text").length){
// $(".delivery_time").hide();
// };
$('[data-id="model"]').on('click', function(){

  var thisModel = $(this).data('target');
  $(thisModel).show();
  $(thisModel).find('[data-close="model"]').click(function(){ 
    $(thisModel).hide();
  });
  $(window).click(function(event){
    if('#'+event.target.id == thisModel){
      $(thisModel).hide();
    }
  });
$(".modal-body").show();
});

//customer 

// Read More Less
 $('.custom_cart .cart-item__quantity .quantity__input').on('change',function(){
    setTimeout(function(){
       window.location.reload();
    }, 1000);
     });
    $('.read_more_less').on('click', function(e){
      e.preventDefault();
      if($('.product-description-full:visible')[0]){
        $('.product-description-full').fadeOut(function(){ 
          $('.product-description-short').fadeIn();
        });
      }else{
        $('.product-description-short').fadeOut(function(){ 
          $('.product-description-full').fadeIn();
        });
      }
    });

// js comment
  // js comment end
var cust_sortval = $('.sort-per-page select.num').find("option:selected").attr("data-attr");
$(".custom__showcount").html(cust_sortval);

    $('.sort-per-page select.num').on('change', function(){

     // console.log(cust_sortval);

      window.location.replace($(this).val());
//console.log(url);

    });

// filter blank div hide
  var li_length = $('.custom_gender-content li').length;
    var cust_class = $("#Facet-5-template--15255027810365__product-grid");
   var cust_mobileclass = $("#FacetMobile-5-template--15255027810365__product-grid");
    if (li_length === 0) {
        $('.custom_gender-content').css('display', 'none');
        cust_class.parents('.custom__gender-list').addClass('cust__blankfilter');
 cust_mobileclass.parents('.custom__gender-list').addClass('cust__blankfilter');
    }

var li_length_1 = $('.custom__main-data li').length;
    var cust_class_1 = $("#Facet-4-template--15255027810365__product-grid");
var cust_mobile = $("#FacetMobile-4-template--15255027810365__product-grid");

console.log(li_length_1);
    if (li_length_1 === 0) {
        cust_class_1.parents('.custom__tag-filter').addClass('cust__blankfilter');
  cust_mobile.parents('.custom__tag-filter').addClass('cust__blankfilter');
    }
// End  filter blank div hide

  $(".custom_three_grid").click(function(){
      $(".custom_three_grid").toggleClass("custom_active");
      $(".custom_four_grid").removeClass("custom_active");   
    $(".custom_list_grid").removeClass("custom_active");    
      $(".product-grid").removeClass("grid--4-col-desktop");
      $(".product-grid").removeClass("custom-list-grid");   
      $(".product-grid").addClass("grid");    
      $(".product-grid").addClass("grid--2-col-tablet-down");      
      $(".product-grid").addClass("grid--3-col-desktop");
  
  });  
  $(".custom_four_grid").click(function(){
$(".custom_four_grid").addClass("custom_active");
$(".custom_three_grid").removeClass("custom_active");
    $(".custom_list_grid").removeClass("custom_active");    
      $(".product-grid").removeClass("grid--3-col-desktop");
      $(".product-grid").removeClass("custom-list-grid");
      $(".product-grid").addClass("grid");    
      $(".product-grid").addClass("grid--2-col-tablet-down");     
      $(".product-grid").addClass("grid--4-col-desktop");
  
  });
  $(".custom_list_grid").click(function(){
    $(".custom_list_grid").addClass("custom_active");
    $(".custom_four_grid").removeClass("custom_active");
    $(".custom_three_grid").removeClass("custom_active")
      $(".product-grid").removeClass("grid");    
      $(".product-grid").removeClass("grid--2-col-tablet-down");    
      $(".product-grid").removeClass("grid--3-col-desktop");
      $(".product-grid").removeClass("grid--4-col-desktop");
      $(".product-grid").addClass("custom-list-grid");
  
  });  

// const detailsElements = document.querySelectorAll('.accordion details');
//         detailsElements.forEach((details) => {
//             details.addEventListener('click', () => {
//                 // Remove the 'open' attribute from all other details elements
//                 detailsElements.forEach((otherDetails) => {
//                     if (otherDetails !== details) {
//                         otherDetails.removeAttribute('open');
//                     }
//                 });
//             });
//         });
// $('.accordion summary').bind('click', function(e) { 
//     e.preventDefault();
    
//     $('.accordion__content ').toggleClass('animated');
// });

                    });


$(document).ready(function() {
    $('.accordion details').click(function() {
        var clickedDetails = this;

        $('.accordion details').each(function() {
            if (this !== clickedDetails) {
                $(this).removeAttr('open');
 $('html, body').animate({
    scrollTop: $(".custom-collapsibles").offset().top
}, -100);
            }
        });
    });
});